import Vue from 'vue'
// import * as VueGoogleMaps from 'vue2-google-maps'
import 'leaflet/dist/leaflet.css'; 
import App from './App.vue'

Vue.config.productionTip = false

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyDhXtEbqSjpmxFZK_a91aNKRULxRWwcqdA',
//     libraries: 'places',
//   }
// });